<template>
    <applications-find
        v-slot="{
            data: application,
            error,
            is_loading,
            has_loaded,
            find
        }"
        :params="{
            application: $route.params.application
        }"
        :include="[
            'applicant(include:tenant)',
            'coapplicants(include:tenant)',
            'listing(include:property(include:address))',
            'note'
        ]"
    >
        <div>
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <base-alert
                    v-if="application.rejected_at"
                    level="warning"
                    class="mb-6"
                >
                    <template slot="heading">Application Rejected</template>

                    <template slot="content">
                        <p>This application was rejected on {{ application.rejected_at | moment('D MMM, YYYY') }}.</p>
                    </template>
                </base-alert>

                <details-card class="mb-6">
                    <template slot="header">
                        <div class="flex-grow mr-3 overflow-hidden">
                            <h1 class="text-lg font-normal truncate">
                                Application for {{ application.listing.property.name }}
                            </h1>
                        </div>

                        <div
                            v-if="is_loading"
                            class="w-6 h-6 mr-3"
                        >
                            <base-svg
                                name="icon-loading"
                                class="w-full h-full"
                            />
                        </div>

                        <edit-dropdown
                            :application="application"
                            class="flex-none"
                            @success="find"
                        />
                    </template>
                    <template slot="body">
                        <grid-layout>
                            <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                                <div class="text-xs text-label">Listing</div>
                                <div class="text-sm">
                                    <router-link
                                        :to="{
                                            name: 'dashboard.landlords.listings.show',
                                            params: {
                                                listing: application.listing.uuid
                                            }
                                        }"
                                        class="text-blue"
                                    >
                                        {{ application.listing.property.name }}
                                    </router-link>
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                                <div class="text-xs text-label">Applied at</div>
                                <div class="text-sm">
                                    {{ application.submitted_at | moment('DD/MM/YYYY') }}
                                </div>
                            </grid-layout-item>
                        </grid-layout>
                    </template>
                </details-card>

                <notes-card
                    :note="application.note"
                    :notable="application"
                    class="mb-6"
                />

                <div class="mb-6 bg-white rounded shadow">
                    <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
                        <h3 class="flex-grow text-base font-normal">
                            Applicants
                        </h3>

                        <div class="flex-none">
                            <chats-store-button
                                :personas="_.chain([
                                    application.applicant,
                                    ...application.coapplicants.data
                                ]).map('tenant').filter().value()"
                            >
                                Message Applicants
                            </chats-store-button>
                        </div>
                    </header>

                    <applicants-list
                        :applicants="[
                            application.applicant,
                            ...application.coapplicants.data
                        ]"
                    />
                </div>
            </template>
        </div>
    </applications-find>
</template>

<script>
    import ApplicantsList from '../../../../components/applicants-list'
    import ApplicationsFind from '../../../../components/applications-find'
    import ChatsStoreButton from '../../../../components/chats-store-button'
    import DetailsCard from '../../../../components/details-card'
    import EditDropdown from './show/edit-dropdown'
    import NotesCard from '../../../../components/notes-card'

    export default {
        components: {
            ApplicantsList,
            ApplicationsFind,
            ChatsStoreButton,
            DetailsCard,
            EditDropdown,
            NotesCard
        }
    }
</script>
